@let isReadOnly = readonly || (userFacadeService.isReadOnly() && !ignoreReadOnly);

<div
  #wrapperElement
  class="input-editor link-tooltip"
  [class.vertical-resize]="enableVerticalResize"
  [id]="name + '-wrapper'"
  [style]="style"
>
  <div class="label-row">
    <label [for]="name"
      >{{ label + (required ? '*' : '') }}<app-label-icon *ngIf="labelIcon" [data]="labelIcon"
    /></label>
  </div>
  <p-editor
    #pEditor
    #model="ngModel"
    [bounds]="'#' + name + '-wrapper'"
    [class.has-errors]="displayErrors"
    [id]="name"
    [formats]="formats"
    [modules]="modules"
    [name]="name"
    [readonly]="isReadOnly || isDisabled"
    [(ngModel)]="value"
    [disabled]="isDisabled"
    (onInit)="onEditorInit($event)"
    (onTextChange)="onTextChange($event)"
  >
    <ng-template pTemplate="header">
      <span class="ql-formats">
        <ng-container *ngFor="let format of formats">
          <button
            type="button"
            [class]="'ql-' + format"
            [disabled]="isReadOnly || isDisabled"
            [attr.aria-label]="format[0].toUpperCase() + format.substring(1)"
          ></button>
        </ng-container>
      </span>
    </ng-template>
  </p-editor>
</div>
<div
  class="input-editor-error-container"
  *ngIf="displayErrors"
  [style.width]="style.width"
  [attr.id]="name + '-error'"
  role="alert"
  aria-atomic="true"
>
  <app-input-error *ngFor="let error of errors" [message]="error" />
</div>
